import { useId, useState } from 'react';
import { Label } from '../Label/Label';
import { ErrorMessage } from '../ErrorMessage/ErrorMessage';
import { Select } from '../Select/Select';
import { Description } from '../Description/Description';
import classes from './FormSelect.module.css';

type FormSelectProps = {
  label: string;
  description?: string;
  required?: boolean;
  options: Array<{ label: string; value: any }>;
  errorMessage?: string;
  defaultValue?: string;
  onChange: (value: any) => void;
  placeholder?: string;
  labelSpacing?: boolean;
};

export const FormSelect = ({
  label,
  description,
  required = false,
  options,
  errorMessage,
  defaultValue = '',
  placeholder,
  onChange,
  labelSpacing = true,
}: FormSelectProps) => {
  const selectId = useId();
  const defaultSelectedOption = defaultValue || options[0]?.value;
  const [, setSelectedOption] = useState<string>(defaultSelectedOption);

  const handleSelect = (value: string) => {
    setSelectedOption(value);
    onChange(value);
  };
  return (
    <div className={classes.container}>
      <Label
        label={label}
        htmlFor={selectId}
        size={'ml'}
        required={required}
        spacing={labelSpacing}
      />
      {description && (
        <Description description={description} id={selectId} size={'ml'} />
      )}
      <Select
        placeholder={placeholder}
        options={options}
        value={defaultValue}
        onChange={handleSelect}
        isError={Boolean(errorMessage)}
        aria-invalid={Boolean(errorMessage)}
      />
      {errorMessage && <ErrorMessage error={errorMessage} size={'ml'} />}
    </div>
  );
};
